import { BlockUiService } from './service/helper/block-ui.service';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BlockUiComponent } from './components/block-ui/block-ui.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BlockUiComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'de-portal-web';
  constructor(public blockUiService: BlockUiService) {}
}
